import React from 'react'
import './Resources.css'

const Resources = () => {
  return (
    <div className='projects' align="center">
      <br></br>
      <h2>Resources used in that project.</h2>
      <div className='home'>
        <br></br>
          <p className='info'>
          1. Loyalty Programs - Starbucks Rewards: Starbucks Rewards is a loyalty program that offers customers free drinks and food items after they accumulate a certain number of stars. This program encourages customers to keep coming back to Starbucks to earn rewards, and it benefits Starbucks by increasing sales.
          </p>
          <a className='link' href='https://www.starbucks.com/rewards'>
            Click to learn more.
          </a>
          <br></br>
          <p className='info'>
          2. Bundling Products - Apple's iPhone Bundle: Apple offers a bundle deal for its iPhone that includes a phone case, AppleCare+ protection plan, and a set of AirPods. This bundle deal encourages customers to buy all the products together, and it benefits Apple by increasing sales.
          </p>
          <a className='link' href='https://www.bestbuy.com/site/lively-premium-health-safety-package-for-apple-watch-2-year-commitment-34-99-per-month-digital/6510590.p?skuId=6510590'>
            Click to learn more.
          </a>
          <br></br>
          <p className='info'>
          3. Free Trials - Paramount Free Trial: Paramount offers a one-month free trial to new customers. This encourages customers to try out the streaming service without committing to a purchase, and it benefits Netflix by increasing the likelihood that customers will become paying subscribers.
          </p>
          <a className='link' href='https://www.paramountplus.com/?gclsrc=aw.ds&&ref=__iv_p_1_g_139152481561_w_aud-677684914512:kwd-1647156705275_h_9014969_ii__d_c_v__n_g_c_592899612945_l__t__e__r__vi__&ftag=PPM-02-10aeg8j&vndid=google$null$null$netflix%20trial&gclid=Cj0KCQjwz6ShBhCMARIsAH9A0qVp2LjZzatH65Kk0Aigp_AjeYnNtLVoOoGMLJlIMPHf1NKBWvs9Rl4aAkTjEALw_wcB&gclsrc=aw.ds&_ivgu=868116cb-5cf1-453d-8d4a-6677bb582001'>
            Click to learn more.
          </a>
          <br></br>
          <p className='info'>
          4. Discounts - Amazon Prime Day: Amazon's Prime Day event offers discounts on a wide range of products for Amazon Prime members. This encourages customers to make purchases on Amazon, and it benefits Amazon by increasing sales.
          </p>
          <a className='link' href='https://www.amazon.com/primeday'>
            Click to learn more.
          </a>
          <br></br>
          <p className='info'>
          5. Buy One Get One Free - McDonald's BOGO Deal: McDonald's frequently offers BOGO deals on its menu items, such as buy one Big Mac, get one for free. This encourages customers to buy more of the product, and it benefits McDonald's by increasing sales.
          </p>
          <a className='link' href='https://www.chewboom.com/2023/01/02/buy-one-get-one-for-1-deal-spotted-at-mcdonalds/'>
            Click to learn more.
          </a>
          <br></br>
          <p className='info'>
          6. Referral Programs - Dropbox Referral Program: Dropbox offers a referral program where users can earn extra storage space for free by inviting their friends to sign up for Dropbox. This benefits the user by giving them extra storage space, and it benefits Dropbox by increasing the number of users on the platform.
          </p>
          <a className='link' href='https://help.dropbox.com/ru-ru/storage-space/earn-space-referring-friends'>
            Click to learn more.
          </a>
          <br></br>
      </div>
      <br></br>
    </div>
  )
}
export default Resources